import FieldsGeneratorRaw from './../../FieldsGenerator'
export default {
  name: 'Container',
  mixins: [FieldsGeneratorRaw],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'inputFromContainer'
  },
  data () {
    return {
      items: this._.cloneDeep(this.config.items),
      value: this._.cloneDeep(this.modelProps),
      notListenValue: false,
      notListenModel: false
    }
  },
  created () {
    this.addVVScope()
  },
  methods: {
    formatString (string) {
      // eslint-disable-next-line no-eval
      return eval(string)
    },
    async validate () {
      let vm = this
      Object.keys(this.items).forEach(element => {
        try {
          let obj = this.items[element]
          vm.$refs[`${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate()
        } catch (error) {
          console.log('Error from container:' + error)
        }
      })
    },
    addVVScope() {
      for(let key in this.items) {
        this.items[key].vvScope = this.config.vvScope
        this.initDataForContainer(this.items[key])
      }
    },
    childInput() {
      this.$emit('inputFromContainer', this._.merge(this.modelProps, this.value))
    }
  },
  watch: {
    config(newValue) {
      this.items = newValue.items
      this.addVVScope()
    },
    value: {
      handler: function(newValue) {
        this.notListenModel = true
        if(!this.notListenValue) {
          // console.log('container watch', JSON.parse(JSON.stringify(this.value)))
          this.$emit('inputFromContainer', this._.merge(this.modelProps, this.value))
        }
        this.notListenValue = false
      },
      deep: true
    },
    modelProps: {
      handler: function(newValue) {
        this.notListenValue = true
        if(!this.notListenModel) {
          this.value = this._.cloneDeep(newValue)
        }
        this.notListenModel = false
      },
      deep: true
    }
  }
}
